module.exports = __webpack_public_path__ + "img/styria-media-group-logo.e63d34af.svg";